import { Box, Button, Typography } from "@mui/material";
import FilterControl from "../FilterControl/FilterControl";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SearchInput from "../SearchInput/SearchInput";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function OperatorsTableActionBar({
  title,
  options,
  sortBy,
  onSortChange,
  sortOrderLabel,
  onSortOrderClick,
  searchValue,
  onSearchChange,
  onCalendarClick,
  onResetFilters,
  onAdd,
  addLabel = "Додати",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      {/* Left side */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="h6">{title}</Typography>
        {onAdd && (
          <Button
            variant="outlined"
            onClick={onAdd}
            sx={{
              borderColor: "#172036",
              borderRadius: "4px",
              px: 1.5,
              height: 32,
              textTransform: "none",
            }}
          >
            {addLabel}
          </Button>
        )}
      </Box>

      {/* Right side */}
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <FilterControl
          setSortBy={onSortChange}
          options={options}
          sortBy={sortBy}
        />

        <Button
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            borderColor: "#172036",
            borderRadius: "4px",
            px: 1.5,
            height: 36,
            borderWidth: 1,
          }}
          onClick={onSortOrderClick}
        >
          <Box display="flex" flexDirection="column">
            <KeyboardArrowUpIcon
              fontSize="small"
              sx={{
                height: "13px",
                color:
                  sortOrderLabel === "Зростання" ? "primary.main" : "grey.400",
              }}
            />
            <KeyboardArrowDownIcon
              fontSize="small"
              sx={{
                height: "13px",
                color:
                  sortOrderLabel === "Спадання" ? "primary.main" : "grey.400",
              }}
            />
          </Box>
          {sortOrderLabel}
        </Button>

        <Button
          variant="outlined"
          onClick={onCalendarClick}
          sx={{
            borderColor: "#172036",
            borderRadius: "4px",
            px: 1.5,
            height: 36,
            borderWidth: 1,
          }}
        >
          <CalendarTodayIcon />
        </Button>

        <SearchInput
          value={searchValue}
          onChange={onSearchChange}
          placeholder="Пошук оператора..."
        />
        <IconButton onClick={onResetFilters}>
          <RefreshIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
